"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A simple Dropdown item that renders a text label.
 */
const DropdownItemDefault = allProps => {
  const {
    children,
    defaultItem,
    onClick,
    ...props
  } = allProps;
  const clickHandler = e => {
    e.stopPropagation();
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default.Item, _extends({
    className: children === defaultItem ? 'active' : '',
    as: "button",
    onClick: clickHandler
  }, props), children);
};
DropdownItemDefault.propTypes = {
  /**
   * The contents of the Dropdown Item
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The text of the active dropdown item.
   */
  defaultItem: _propTypes.default.string,
  /**
   * The event listener/handler for click events.
   */
  onClick: _propTypes.default.func
};
DropdownItemDefault.displayName = 'Dropdown.DefaultItem';
var _default = exports.default = DropdownItemDefault;